import { get } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config'; // Import the helper function

const apiNamePath = PRESCRIPTSURE.DRUGSAPI; // API endpoint from constants

const drugsApiService = {
  async getDrugInfo(drugId) {
    try {
      const sessionToken = await getSessionToken(); // Fetch the token dynamically

      const drugInfo = get({
        apiName: apiNamePath,
        path: `/get_drug_info`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            drug_id: drugId,
          },
        },
      });
      const response = (await drugInfo.response).body.json();
      return response;
    } catch (error) {
      console.error('Error fetching drug info:', error);
    }
  },

  async getDrugMonograph(monographId) {
    try {
      const sessionToken = await getSessionToken(); // Fetch the token dynamically
      const drugMonographInfo = await get({
        apiName: apiNamePath,
        path: `/get_drug_drug_monograph`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            monograph_id: monographId,
          },
        },
      });
      const response = (await drugMonographInfo.response).body.json();
      return response;
    } catch (error) {
      console.error('Error fetching drug monograph:', error);
    }
  },

  async getDrugFoodMonograph(monographId) {
    try {
      const sessionToken = await getSessionToken(); // Fetch the token dynamically
      const drugFoodMonographInfo = await get({
        apiName: apiNamePath,
        path: `/get_drug_food_monograph`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            monograph_id: monographId,
          },
        },
      });
      const response = (await drugFoodMonographInfo.response).body.json();
      return response;
    } catch (error) {
      console.error('Error fetching food monograph:', error);
    }
  },

  async getPregnancyMonograph(monographId) {
    try {
      const sessionToken = await getSessionToken(); // Fetch the token dynamically
      const drugPregnancyMonographInfo = await get({
        apiName: apiNamePath,
        path: `/get_pregnancy_monograph`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            monograph_id: monographId,
          },
        },
      });
      const response = (await drugPregnancyMonographInfo.response).body.json();
      return response;
    } catch (error) {
      console.error('Error fetching pregnancy monograph:', error);
    }
  },

  async getDrugSearch(drugName) {
    try {
      // return drugListJson;
      const sessionToken = await getSessionToken(); // Fetch the token dynamically
      const drugDrugSearchInfo = await get({
        apiName: apiNamePath,
        path: `/drug_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            drug_name: encodeURI(drugName),
          },
        },
      });

      const response = (await drugDrugSearchInfo.response).body.json();
      return response;
    } catch (error) {
      console.error('Error fetching drug search:', error);
    }
  },
};

export default drugsApiService;
